/**
 * These are the possible error codes that an
 * AuthenticationError can hold.
 */
export enum AuthErrorCode {
    /** email address is not valid */
    'invalid-email' = 'invalid-email',
    /** the user corresponding to the given email has been disabled */
    'user-disabled' = 'user-disabled',
    /** there is no user corresponding to the given email */
    'user-not-found' = 'user-not-found',
    /** the password is invalid for the given email, or the account corresponding
     * to the email does not have a password set. */
    'wrong-password' = 'wrong-password',
    /** the maximum allowed login attempts are reached, usually you can try again later */
    'too-many-requests' = 'too-many-requests',
    /** no response from server within the time limit */
    'request-timeout' = 'request-timeout',
    /** unknown server error */
    'unknown-server-error' = 'unknown-server-error',
    /** other error */
    'other' = 'other'
}

/**
 * Custom error thrown when authentication fails.
 */
export class AuthenticationError extends Error {
  public readonly code: AuthErrorCode

  constructor(code: AuthErrorCode, message?: string) {
    super(message)
    this.code = code
    Object.setPrototypeOf(this, AuthenticationError.prototype)
  }
}
